import React from 'react';
import { useTranslation } from 'react-i18next';

import Hint from './hint';

interface Props {
  className: string;
  domainPrice: string;
  translationKey: string;
  proPrice?: string;
}

const FreeDomainFirstYearHint: React.FunctionComponent<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <Hint
      className={props.className}
      html={t(props.translationKey, {
        price: props.domainPrice,
        proPrice: props.proPrice,
      })}
    />
  );
};

export default FreeDomainFirstYearHint;
